module.exports = __webpack_public_path__ + "img/yy.bc8f23eb.png";